interface StatRingProps {
  label: string
  value: number
  total: number
  color: string // stroke color, e.g. '#2563eb'
  onClick?: () => void
}

/** A single "N out of total" ring row — click to open the detail modal.
 * Kept dependency-free (raw SVG stroke-dasharray) rather than pulling in a
 * charting library for three small rings. */
export default function StatRing({ label, value, total, color, onClick }: StatRingProps) {
  const pct = total > 0 ? Math.min(value / total, 1) : 0
  const radius = 22
  const circumference = 2 * Math.PI * radius
  const dashOffset = circumference * (1 - pct)

  return (
    <button
      onClick={onClick}
      disabled={!onClick}
      className="w-full flex items-center gap-4 p-3 rounded-lg border border-neutral-200 hover:bg-neutral-50 transition-colors text-left disabled:cursor-default disabled:hover:bg-transparent"
    >
      <svg width="56" height="56" viewBox="0 0 56 56" className="shrink-0">
        <circle cx="28" cy="28" r={radius} fill="none" stroke="#e5e7eb" strokeWidth="6" />
        <circle
          cx="28" cy="28" r={radius} fill="none"
          stroke={color} strokeWidth="6" strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
          transform="rotate(-90 28 28)"
        />
      </svg>
      <div>
        <p className="text-sm text-neutral-600">{label}</p>
        <p className="text-xl font-bold text-neutral-900">{value}</p>
      </div>
    </button>
  )
}
